import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './Hero.css';

const Hero: React.FC = () => {
  const { t } = useLanguage();
  const [currentWord, setCurrentWord] = useState<number>(0);
  const words = t('hero.title.animatedWords');

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWord((prev) => (prev + 1) % words.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [words.length]);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero" role="banner" aria-label="Main hero section">
      <div className="hero-background" aria-hidden="true"></div>
      <div className="container">
        <div className="hero-content">
          <header>
            <h1 className="hero-title">
              {t('hero.title.prefix')}{' '}
              <span className="hero-word-animation" aria-label={`Currently showing: ${words[currentWord]}`}>
                {words[currentWord]}
              </span>
              {' '}{t('hero.title.suffix')}
            </h1>
          </header>
          
          <p className="hero-subtitle">
            {t('hero.subtitle')}
          </p>
          
          <div className="hero-features">
            <div className="hero-feature">
              <span className="hero-feature-icon">🚗</span>
              <span>{t('hero.features.bodyParts')}</span>
            </div>
            <div className="hero-feature">
              <span className="hero-feature-icon">⚙️</span>
              <span>{t('hero.features.engines')}</span>
            </div>
            <div className="hero-feature">
              <span className="hero-feature-icon">🔧</span>
              <span>{t('hero.features.components')}</span>
            </div>
          </div>
          
          <div className="hero-buttons">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="btn"
              aria-label={t('hero.ariaLabels.learnHowToSell')}
            >
              {t('hero.buttons.howToSell')}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="btn btn-secondary"
              aria-label={t('hero.ariaLabels.contactToSell')}
            >
              {t('hero.buttons.sellYourParts')}
            </button>
          </div>
          
          <div className="hero-stats">
            <div className="hero-stat">
              <span className="hero-stat-number">{t('hero.stats.pickupService.number')}</span>
              <span className="hero-stat-label">{t('hero.stats.pickupService.label')}</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">{t('hero.stats.allParts.number')}</span>
              <span className="hero-stat-label">{t('hero.stats.allParts.label')}</span>
            </div>
            <div className="hero-stat">
              <span className="hero-stat-number">{t('hero.stats.ownTransport.number')}</span>
              <span className="hero-stat-label">{t('hero.stats.ownTransport.label')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
